<app-error-modal *ngIf="logOutWarningModal" [buttonLeft]="textBtnUp" [buttonRight]="textBtnDown" [title]="titleModal"
    [subtitle]="subtitleModal" [iconType]="iconModal" [isCloseable]="false" (selectedOption)="modalOptionWarningSelect($event)">
</app-error-modal>
<app-error-modal *ngIf="logOutInfoModal" [buttonLeft]="textBtnUp" [buttonRight]="textBtnDown" [title]="titleModal"
    [subtitle]="subtitleModal" [iconType]="iconModal" [isCloseable]="false" (selectedOption)="modalOptioInfoSelect($event)">
</app-error-modal>
<app-error-modal *ngIf="logOutEndModal" [buttonLeft]="textBtnUp" [buttonRight]="textBtnDown" [title]="titleModal"
    [subtitle]="subtitleModal" [iconType]="iconModal" [isCloseable]="false" (outputValue)="logOut()">
</app-error-modal>
